// extracted by mini-css-extract-plugin
export default {"myButton":"button_myButton__gKN5o"};